'use strict';

import metaModel from '~/shared/src/utilities/metaModel';


class MetaModelResolver {
    constructor() {
        return new Proxy( metaModel, this );
    }

    get( target : any, attribute : number | string | symbol ) : any {
        if ( typeof target[ attribute ] === 'function' ) {
            return ( target[ attribute ] as Function ).bind( target );
        }
        else if ( typeof target[ attribute ] === 'object' ) {
            return new Proxy( target[ attribute ], this );
        }
        else {
            return target[ attribute ];
        }
    }
}

export default MetaModelResolver;
